import {Trainings} from './Trainings';
export default Trainings;
